/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Estimated_CostInputs */



/**
* | output |
* | --- |
* | "Estimated Cost" |
*
* @param {Estimated_CostInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const estimated_cost = /** @type {((inputs?: Estimated_CostInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Estimated_CostInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coût estimé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geschätzte Kosten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Costo stimato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ориентировочная стоимость")
	if (locale === "es") return /** @type {LocalizedString} */ ("Costo estimado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预计成本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("推定費用")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमानित लागत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Custo estimado")
	return /** @type {LocalizedString} */ ("Estimated Cost")
});